// В режиме Switch Time кнопки +/- на поле Time шагают минутами, а не секундами.
export const MINUTE_STEP = 60;
// Потолок попапа (23:59:30) — когда сервер не задал max (max_expiration_sec = 0).
export const MAX_DURATION_SECONDS = 23 * 3600 + 59 * 60 + 30;
